module.exports = __webpack_public_path__ + "static/media/ic_display_hover.c89d18a9.svg";